export const LINK_FACEBOOK = 'https://www.facebook.com/sofiadateblog/';
export const LINK_INSTAGRAM = "https://www.instagram.com/sofia_date/";
export const LINK_TWITTER = "https://twitter.com/sofiadate_site";
export const LINK_YOUTUBE = "https://www.youtube.com/channel/UCVz0JuxuImIvNF3Qn4JMy5g";